"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxFileMigrationLog_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Patient_1 = require("./Patient");
var BoxFileMigrationLog_Factory = /** @class */ (function () {
    function BoxFileMigrationLog_Factory() {
    }
    BoxFileMigrationLog_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            BoxFileId: model.BoxFileId,
            Description: model.Description,
            MigrationStatus: model.MigrationStatus,
            Patient: Patient_1.Patient_Factory.CreateIncoming(model.Patient),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            SenseiCloudFileId: model.SenseiCloudFileId,
        };
        return result;
    };
    BoxFileMigrationLog_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            BoxFileId: model.BoxFileId,
            Description: model.Description,
            MigrationStatus: model.MigrationStatus,
            Patient: Patient_1.Patient_Factory.CreateOutgoing(model.Patient),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            SenseiCloudFileId: model.SenseiCloudFileId,
        };
        return result;
    };
    return BoxFileMigrationLog_Factory;
}());
exports.BoxFileMigrationLog_Factory = BoxFileMigrationLog_Factory;
